import { createQubo } from 'qubo'

import { maLogger } from '@/base/logger'

export function checkUserProductPermissions(userProducts, rule) {
  try {
    const qubo = createQubo(userProducts)
    const conditions = qubo.evaluate(rule)
    return conditions.some(isAllowed => isAllowed)
  }
  catch (error) {
    maLogger.warn('[useSectionAccess]', error)
    return false
  }
}
